import {Component, OnInit} from '@angular/core';
import {CommonInputComponent} from '../common-input/common-input.component';

@Component({
  selector: 'app-number-input',
  templateUrl: './number-input.component.html',
  styleUrls: ['./number-input.component.scss']
})
export class NumberInputComponent extends CommonInputComponent implements OnInit {

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.actualValue = this.ngModelObject;
  }
}
